import { ContextAction } from '$modules/onboarding/types';

export type AuthenticationState = {
  mobile?: string;
  email?: string;
  countryCode?: string;
  logInType: string;
  consentMobile?: boolean;
  consentEmail?: boolean;
  maskedEmail?: string;
  isExistingUser?: boolean;
};

export const authenticationInitial = {
  countryCode: '',
  mobile: '',
  email: '',
  logInType: '',
  consentMobile: false,
  consentEmail: false,
  maskedEmail: ''
};

export type AuthenticationAction = {
  type: ContextAction.setAuthenticationConfig;
  payload: AuthenticationState;
};

export const authenticationReducer = (
  state: AuthenticationState,
  action: AuthenticationAction
): AuthenticationState => {
  switch (action.type) {
    case ContextAction.setAuthenticationConfig: {
      const {
        logInType,
        countryCode = '',
        mobile = '',
        email = '',
        consentMobile = false,
        consentEmail = false,
        maskedEmail,
        isExistingUser
      } = action.payload;
      return {
        ...state,
        logInType,
        countryCode,
        mobile,
        email,
        consentMobile,
        consentEmail,
        maskedEmail,
        isExistingUser
      };
    }
    default:
      return state;
  }
};
